import LocationBin from ".";

export const locationBinRoutes = [
  {
    path: "/locationBin",
    element: <LocationBin />,
  },
];
